/*
 * @Author: Code-HHX
 * @Date: 2022-04-19 10:32:17
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-04-19 14:43:15
 * @Description:常用工具类
 */

//验证变量是否为空
export function isNullAndEmpty(obj) {
  if (typeof obj == "string") {
    obj = obj.trim();
  }
  if (obj === null || obj === "" || obj === undefined || obj === "null") {
    return true;
  } else {
    return false;
  }
}

//验证邮箱格式
export function isEmail(str) {
  var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.(.*?)$/;
  return reg.test(str);
}

export function handleHexStringToUInt16(hex) {
  let hexStr = hex;
  if (hexStr.length % 2 !== 0) {
    hexStr = `0${hexStr}`;
  }

  let buffer = Buffer.alloc(2);
  buffer[0] = parseInt(hexStr.slice(0, 2), 16);
  buffer[1] = parseInt(hexStr.slice(2, 4), 16);
  const dataView = new DataView(buffer.buffer);
  return dataView.getUint16(0, true);
}

export function convertTagId(tagId) {
  if (!(navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1)) {
    let tagIdSize = tagId.length / 2;
    let tagIdList = [];
    for (let i = 0; i < tagIdSize; i++) {
      tagIdList.push(tagId.slice(i * 2, i * 2 + 2));
    }
    tagId = tagIdList.reverse().join("").toUpperCase();
  }
  return tagId
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}


export function isAndroid() {
  return (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1);
}
export function androidWriteFail(isRead) {
  return {
    title: "",
    message: `${(isRead? 'Read':'Write')} fail!`,
    icon: require('@/assets/android_nfc_fail.svg'),
    status: ANDROID_NFC_FAIL
  }
}

export function androidWriteSuccess(isRead) {
  return {
    title: "",
    message: `${(isRead? 'Read':'Write')} Success!`,
    icon: require('@/assets/android_nfc_success.svg'),
    status: ANDROID_NFC_SUCCESS
  }
}
export const ANDROID_NFC_START = 0;
export const ANDROID_NFC_SUCCESS = 1;
export const ANDROID_NFC_FAIL = -1;